export default function WhyChooseSection() {
  const reasons = [
    {
      icon: 'ri-star-line',
      title: 'Najlepsze produkty',
      desc: 'Odkrywaj popularne produkty zanim staną się popularne. Nasze listy są regularnie aktualizowane.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Gotowe listy',
      desc: 'Nie trać czasu na szukanie tysięcy ofert. Wszystko masz uporządkowane w jednym miejscu.',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Poradniki zakupowe',
      desc: 'Dowiedz się jak bezpiecznie korzystać z Kakobuy i unikaj typowych błędów początkujących.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sprawdzone informacje',
      desc: 'Każdy produkt przechodzi weryfikację. Otrzymujesz tylko sprawdzone linki i dane kontaktowe.',
    },
    {
      icon: 'ri-global-line',
      title: 'Dla polskich klientów',
      desc: 'Informacje o wysyłce do Polski, cłach i procedurach celnych przygotowane specjalnie dla Ciebie.',
    },
    {
      icon: 'ri-time-line',
      title: 'Oszczędność czasu',
      desc: 'Zamiast przeszukiwać setki stron, znajdź wszystko w kilka sekund dzięki naszej bazie.',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-3 text-center">
          Dlaczego Polacy wybierają Kakobuy Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-8 max-w-xl mx-auto">
          Dołącz do tysięcy zadowolonych użytkowników, którzy oszczędzają czas i pieniądze dzięki naszym listom produktów.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reasons.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center text-center p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-accent-300 transition-all duration-200"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-500 mb-3">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}